import { Settings as SettingsIcon } from '@mui/icons-material';
import ApiIcon from '@mui/icons-material/Api';
import InsightsIcon from '@mui/icons-material/Insights';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { handleSignOut, useAuthenticator, useLazyQuery } from '@parkchirp/api-client';
import { HeaderDetailsProps, HeaderProfileDropdown } from '@parkchirp/ui-library';
import NextLink from 'next/link';
import { useCookies } from 'react-cookie';
import { AccessControlComponent, AccessControlledLink } from '~/components/AccessControl';
import { AccessControlledComponents } from '~/constants';
import useAppContext from '~/hooks/useAppContext';
import { getSharedCookieDomain } from '~/utils/getSharedCookieDomain';
import { GET_GITBOOK_JWT } from '../../queries/searchTypeQueries';

const RightSideHeader = () => {
	const { headerDetails } = useAppContext();
	const [cookies, , removeCookie] = useCookies();
	const { authStatus } = useAuthenticator();
	const theme: any = useTheme();
	const isAuthenticated = authStatus === 'authenticated';
	const [fetchJWT] = useLazyQuery(GET_GITBOOK_JWT, {
		context: {
			apiVersion: 'v2',
		},
	});
	const signOut = async () => {
		const cookieDomain = getSharedCookieDomain(window.location.hostname, process.env.NEXT_PUBLIC_MONTHLY_URL);
		await handleSignOut({
			cookies,
			removeCookie,
			UserPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID,
			ClientId: process.env.NEXT_PUBLIC_AWS_APP_CLIENT_ID,
			URL: process.env.NEXT_PUBLIC_MONTHLY_URL,
			cookieDomain,
		});
	};

	return (
		<div id='pca__detail-header-settings_link' style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
			<AccessControlComponent componentName={AccessControlledComponents.SuperAdminAccessArea}>
				<Tooltip title='HQ' arrow>
					<IconButton
						component='a'
						href={process.env.NEXT_PUBLIC_HQ_URL}
						aria-label='HQ'
						data-cy='hq-icon'
						style={{ color: '#fff' }}
						sx={{ p: 0, mt: '8px' }}
					>
						<InsightsIcon style={{ color: '#fff' }} sx={{ fontSize: 28 }} />
					</IconButton>
				</Tooltip>
			</AccessControlComponent>
			<IconButton
				style={{ padding: '0px', marginTop: '8px', color: theme.title.color }}
				data-cy='settings-icon'
				size='small'
			>
				<AccessControlledLink componentName={AccessControlledComponents.SettingsGear} href='/settings/'>
					<SettingsIcon style={{ fontSize: '28px' }} data-cy='org-settings-icon' />
				</AccessControlledLink>
			</IconButton>
			<Tooltip title='API Docs' arrow>
				<IconButton style={{ padding: '0px', marginTop: '8px', color: theme.title.color }} size='small'>
					<NextLink href='/apiDocs'>
						<ApiIcon style={{ fontSize: '28px' }} />
					</NextLink>
				</IconButton>
			</Tooltip>
			<Tooltip title='View Docs' arrow>
				<span>
					<IconButton
						style={{ padding: '0px', color: theme.title.color }}
						size='small'
						onClick={async () => {
							const result = await fetchJWT();
							const { token } = result?.data?.getGitbookJWT || '';
							window.open(`${process.env.NEXT_PUBLIC_GITBOOK_URL}/?jwt_token=${token}`);
						}}
						data-cy='docs-icon'
					>
						<MenuBookOutlinedIcon style={{ fontSize: '30px', marginTop: '0px' }} />
					</IconButton>
				</span>
			</Tooltip>
			<HeaderProfileDropdown
				isAuthenticated={isAuthenticated}
				userInfo={headerDetails?.userInfo}
				signOut={signOut}
			/>
		</div>
	);
};

export default RightSideHeader;
